import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/museum-app/utils/cn'; // Assuming cn utility exists
import { ImageIcon, Play } from 'lucide-react'; // Import icons
import { Button } from '@/components/ui/button'; // Import Button
import { useTranslation } from 'react-i18next'; // Import useTranslation

interface ExhibitGallerySkeletonProps {
  className?: string;
  onClick?: () => void; // Add onClick prop for the button
}

export const ExhibitGallerySkeleton: React.FC<ExhibitGallerySkeletonProps> = ({ className, onClick }) => {
  const { t } = useTranslation();
  return (
    <div className={cn('flex flex-col gap-4 w-full overflow-hidden', className)}>
      {/* Main image skeleton with overlay */}
      <div className="relative aspect-video w-full">
        <Skeleton className="h-full w-full rounded-lg" />
        <div className="absolute inset-0 flex flex-col items-center justify-center rounded-lg bg-black/10 dark:bg-black/30">
           <ImageIcon className="h-16 w-16 text-white/50" />
           {onClick && (
             <Button variant="secondary" size="sm" onClick={onClick} className="mt-4">
                <Play className="mr-2 h-4 w-4" />
                {t('common.viewGallery', 'View Gallery')} {/* Add translation key */}
             </Button>
           )}
        </div>
      </div>
      {/* Thumbnails skeleton */}
      {/* Keep original thumbnail skeletons */}
      <div className="flex gap-2">
        <Skeleton className="h-15 sm:h-20 w-15 sm:w-20 rounded-lg flex-shrink-0" />
        <Skeleton className="h-15 sm:h-20 w-15 sm:w-20 rounded-lg flex-shrink-0" />
        <Skeleton className="h-15 sm:h-20 w-15 sm:w-20 rounded-lg flex-shrink-0" />
        <Skeleton className="h-15 sm:h-20 w-15 sm:w-20 rounded-lg flex-shrink-0" />
      </div>
    </div>
  );
};
